import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import apiClient from '../utils/api';
import { useAuthStore } from '../store/authStore';
import { setToken } from '../utils/tokenStorage';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const setUser = useAuthStore((state) => state.setUser);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleCallback = async () => {
      const hash = location.hash;
      console.log('AuthCallback - Hash:', hash);
      console.log('AuthCallback - Full URL:', window.location.href);
      
      if (!hash) {
        console.log('AuthCallback - No hash, redirecting to home');
        navigate('/');
        return;
      }

      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');
      console.log('AuthCallback - Session ID:', sessionId ? 'found' : 'not found');

      if (!sessionId) {
        console.log('AuthCallback - No session_id in hash');
        setError('Authentication failed: No session ID received');
        setTimeout(() => navigate('/'), 3000);
        return;
      }

      try {
        console.log('AuthCallback - Fetching session data...');
        const response = await apiClient.get('/auth/session-data', {
          headers: { 'X-Session-ID': sessionId }
        });

        const userData = response.data;
        console.log('AuthCallback - Got user data:', userData.email);
        setToken(userData.session_token);
        setUser(userData);

        // Set flag to skip delay in ProtectedRoute
        sessionStorage.setItem('just_authenticated', 'true');

        // Clear the hash from URL
        window.history.replaceState(null, '', window.location.pathname);

        // Navigate to dashboard
        navigate('/dashboard', { replace: true, state: { user: userData } });
      } catch (error) {
        console.error('Auth callback error:', error);
        console.error('Error details:', error.response?.data || error.message);
        setError(`Authentication failed: ${error.response?.data?.detail || error.message}`);
        setTimeout(() => navigate('/'), 3000);
      }
    };

    handleCallback();
  }, [location, navigate, setUser]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="glass-default rounded-2xl p-8 max-w-md">
          <div className="text-center">
            <div className="w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <span className="text-3xl">⚠️</span>
            </div>
            <p className="text-lg text-red-400 mb-2">{error}</p>
            <p className="text-sm text-white/50">Redirecting to home...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="glass-default rounded-2xl p-8">
        <div className="animate-pulse text-center">
          <div className="w-16 h-16 border-4 border-violet-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-lg text-white/70">Authenticating...</p>
          <p className="text-sm text-white/40 mt-2">Please wait...</p>
        </div>
      </div>
    </div>
  );
}
